import { useEffect, useState, useCallback } from "react";

/**
 * Devuelve actions (flatten de actions en motions), actionOptions (a partir de actionOpt)
 * y handlers para togglear show en ambos.
 */
export default function useActionsFromMotions(motions, actionOpt = []) {
  const [actions, setActions] = useState(null);
  const [actionOptions, setActionOptions] = useState(null);

  useEffect(() => {
    const act = [];
    if (Array.isArray(motions)) {
      motions.forEach((m) => {
        if (Array.isArray(m.actions) && m.actions.length > 0) act.push(...m.actions);
      });
    }
    const normalizedActions = act.length ? act.map(a => ({ ...a, show: true })) : null;
    const normalizedOptions = Array.isArray(actionOpt) && actionOpt.length
      ? actionOpt.map(o => ({ ...o, show: true }))
      : null;

    setActions(normalizedActions);
    setActionOptions(normalizedOptions);
  }, [motions, actionOpt]);

  const changeActions = useCallback((act) => {
    // act puede ser { id } o el objeto completo; ajusta la comparación según tu modelo
    if (!act) return;
    setActionOptions(prev => prev ? prev.map(el => el.id === act.id ? { ...el, show: !el.show } : el) : prev);
    setActions(prev => prev ? prev.map(el => el.id === act.id ? { ...el, show: !el.show } : el) : prev);
  }, []);

  return { actions, actionOptions, changeActions, setActions, setActionOptions };
}